import { render, staticRenderFns } from "./EmailNav.vue?vue&type=template&id=f4a263c4&"
import script from "./EmailNav.vue?vue&type=script&lang=js&"
export * from "./EmailNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports